﻿import FavoriteImagesApi from '../FavoriteImagesApi';

export function getFavoriteImage(id) {
    return FavoriteImagesApi.getFavoriteImage(id);
}
